/* mv6-pending.js — "something is happening" feedback for cart actions.
 * 15 Aug 2026 · round 24 · ADDITIVE AND REMOVABLE BY DESIGN.
 *
 * THE REPORT: clicking Start routine / Try now, the drawer's +/−, the nudge
 * chip, a line's remove, or Upgrade & save does nothing visible for 1–2s while
 * Shopify's /cart.js round-trip completes. The work is real and cannot be made
 * faster from here (add + re-read, and the sub upgrade is remove-then-add);
 * what was missing was the acknowledgement.
 *
 * WHAT IT DOES NOT DO — deliberately:
 *   · It does not touch the money path. It calls nothing, changes no price, no
 *     quantity, no plan. It only reads `s.busy`, which mv6-purchase.js has
 *     always emitted around every cart request (state.busy = true; emit()).
 *   · It does not paint on the INSTANT controls (plan cards, bottle tiles) —
 *     those are local state with no network, and a spinner on an action that
 *     already finished is a lie that makes a page feel slower, not faster.
 *   · It adds NO scroll work, no observers, no timers at rest, and no layers:
 *     one delegated click listener and one subscription to a bus that was
 *     already emitting. The spinner is an ::after on the pressed control only,
 *     animating `transform` alone (§4.5 / R-79: transform and opacity are the
 *     only properties that may animate).
 *
 * HOW TO REMOVE IT (both steps are one line each, no other file knows about it):
 *   1. delete the <script src="mv6-pending.js"> tag from mv6-calm-rest.liquid
 *      and mv6-home.liquid;
 *   2. delete the "R-83 PENDING FEEDBACK" block in snippets/mv6-styles.liquid.
 * Nothing else references it. To disable it on a live page without deploying,
 * load any page with ?mv6t=nopending.
 */
(function () {
  'use strict';
  if (window.__mv6Pending) return;              /* both sections load it; once is enough */
  window.__mv6Pending = true;
  if (location.search.indexOf('mv6t=nopending') > -1) return;

  /* Network-backed controls — every one of these ends in a /cart.js call, so the
     busy state lasts exactly as long as the request does. */
  var SEL = '[data-mv6-cta],[data-mv6-empty-add],[data-mv6-upgrade],' +
            '[data-mv6-step],[data-mv6-nudge],[data-mv6-line-remove],[data-mv6-checkout]';

  /* INSTANT controls (round 26, user call). The bottle tiles change local state
     with no request, so s.busy never fires for them — but the buy box still
     re-renders, and the user read that gap as "nothing happened". These get a
     fixed, short acknowledgement instead of a wait: the same ring, 320ms, then
     gone. It is deliberately NOT tied to any promise — there is nothing to wait
     for, and a spinner that outlives the work it describes is the lie this
     module exists to avoid.

     ROUND 28 (user call): REMOVED from the bottle tiles. On a tile the ring
     landed under the tile's own label while the whole card re-rendered around
     it, and at 320ms it read as noise on a control that was already instant.
     Kept for nothing else yet — the list is empty on purpose, so the mechanism
     survives for a future instant control without being wired to one.
     The +/- , chip and remove keep theirs: those wait on the network. */
  var TAP_SEL = '';
  var TAP_MS = 320;

  var armed = null, painted = null, failsafe = 0;

  function clear() {
    if (failsafe) { clearTimeout(failsafe); failsafe = 0; }
    if (painted) { painted.removeAttribute('data-mv6-pending'); painted = null; }
    armed = null;
  }

  function paint(el) {
    if (!el || painted === el) return;
    if (painted) painted.removeAttribute('data-mv6-pending');
    painted = el;
    el.setAttribute('data-mv6-pending', '');
    /* If a request never settles (offline, an app hijacking fetch), the control
       must not stay dead. mv6-purchase.js clears busy in .finally, so this only
       ever fires when the promise itself is lost. */
    failsafe = setTimeout(clear, 8000);
  }

  /* Capture phase: this runs BEFORE the section's own click handler, so the
     element is remembered before the request that sets busy is even issued. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = e.target.closest(SEL);
    armed = el || null;
    if (el || !TAP_SEL) return;
    var tap = e.target.closest(TAP_SEL);
    if (!tap) return;
    /* Its own timer, independent of the busy bus: a tile click can land while a
       cart request is in flight, and neither may clear the other's ring. */
    if (tap.__mv6Tap) clearTimeout(tap.__mv6Tap);
    tap.setAttribute('data-mv6-pending', '');
    tap.__mv6Tap = setTimeout(function () {
      tap.removeAttribute('data-mv6-pending');
      tap.__mv6Tap = 0;
    }, TAP_MS);
  }, true);

  function subscribe() {
    if (!window.mv6 || !window.mv6.on) return false;
    window.mv6.on('change', function (s) {
      if (s && s.busy) { if (armed) paint(armed); }
      else clear();
    });
    return true;
  }

  /* mv6-purchase.js is deferred like this file and normally wins the race; if
     source order ever changes, poll briefly rather than silently doing nothing. */
  if (!subscribe()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (subscribe() || ++tries > 40) clearInterval(iv);
    }, 50);
  }
})();
